import styled from "styled-components";

const NavigationHeader = styled.div`
    margin-bottom: .5rem;
    color: ${props => props.theme.muted};
`;

export default NavigationHeader;